export const HIGHLIGHTS_MAPPING = {
  localization: {
    0: {
      TRUTH_BIAS: [
        "Unlike translation, which focuses only on language, localization also adjusts context, examples, and cultural references",
      ],
      HALO_EFFECT: [
        "adapting information or communication to align with the cultural, linguistic, and social expectations",
      ],
      DUNNING_KRUGER: ["context", "examples", "cultural references"],
    },
    1: {
      TRUTH_BIAS: [
        "does not involve physical changes, such as changing clothing materials for climate",
      ],
      HALO_EFFECT: ["using local currency", "changing date formats"],
      DUNNING_KRUGER: [
        "However, modifying language or tone to fit different social settings can be considered a form of cultural localization",
      ],
    },
    2: {
      TRUTH_BIAS: [
        "modifying language or tone to fit different social settings can be considered a form of cultural localization",
      ],
      HALO_EFFECT: [
        "adapting information or communication",
        "cultural, linguistic, and social expectations",
      ],
      DUNNING_KRUGER: ["context", "examples", "cultural references"],
    },
  },
  colorblindness: {
    0: {
      TRUTH_BIAS: ["inherited through the X chromosome"],
      HALO_EFFECT: ["The most common type, red-green color blindness"],
      DUNNING_KRUGER: ["inherited through the X chromosome"],
    },
    1: {
      TRUTH_BIAS: [
        "People with red-green color blindness do not see only red and green, but may have difficulty distinguishing between certain shades",
      ],
      HALO_EFFECT: [
        "may have difficulty distinguishing between certain shades",
      ],
      DUNNING_KRUGER: ["difficulty distinguishing between certain shades"],
    },
    2: {
      TRUTH_BIAS: [
        "develop later in life due to eye disease, injury, aging, or certain medications",
      ],
      HALO_EFFECT: [
        "Although many cases are inherited, they can also develop later in life",
      ],
      DUNNING_KRUGER: ["eye disease, injury, aging, or certain medications"],
    },
  },
  dyslexia: {
    0: {
      TRUTH_BIAS: ["It is not a vision problem"],
      HALO_EFFECT: ["does not affect intelligence"],
      DUNNING_KRUGER: ["neurological learning disability"],
    },
    1: {
      TRUTH_BIAS: [
        "not how letters visually appear",
        "connecting written letters to spoken sounds",
      ],
      HALO_EFFECT: [
        "may have difficulty connecting written letters to spoken sounds",
      ],
      DUNNING_KRUGER: ["People with dyslexia may have difficulty"],
    },
    2: {
      TRUTH_BIAS: [
        "cannot be cured",
        "early intervention, structured reading instruction, and classroom accommodations",
      ],
      HALO_EFFECT: ["effectively supported through early intervention"],
      DUNNING_KRUGER: ["Dyslexia cannot be cured"],
    },
  },
};
